import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { from, map, of, switchMap } from 'rxjs';
import { TabSdk } from '@techextensor/tab-sdk';

/**
 * Guard for routes accessible by guests (unauthenticated users).
 * If the user is authenticated, they will be allowed to access guest routes.
 */
export const guestGuard: CanActivateFn = (route, state) => {
  // Inject the AuthService to check the authentication status
  const authService = inject(AuthService);

  // Return an observable that resolves to `true` if the user is authenticated
  return authService.check().pipe(
    switchMap((authenticated) => {
      // Check if org info needs to be loaded first
      if (!TabSdk?.store?.getOrgInfo()?.Id) {
        return from(TabSdk.util.loadOrgInfo()).pipe(
          switchMap(() => {
            // After org info is loaded, check if app info needs to be loaded
            if (!TabSdk?.store?.getAppInfo()?.Id) {
              return from(TabSdk.util.loadAppInfo()).pipe(
                map(() => true) // Allow access to the route
              );
            }
            return of(true); // No app info loading needed
          })
        );
      }

      // Org info doesn't need loading, check app info
      if (!TabSdk?.store?.getAppInfo()?.Id) {
        return from(TabSdk.util.loadAppInfo()).pipe(
          map(() => true) // Allow access to the route
        );
      }

      // Nothing needs to be loaded
      return of(true);
    })
  );
};
